import React from 'react';

export default function OrangeLine() {
  return <div className="orange-line" />;
}
